import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class PasswordResetInit {

    constructor(private http: HttpClient) { }

    save(mail: string): Observable<any> {
        return this.http.post('api/account/reset_password/init', mail, {responseType : 'text'});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/init/password-reset-init.service.ts